import { translate } from '@repo/phrase';

import { Filter } from '@/components/filters/filter';
import { TypeFilter } from '@/components/filters/type-filter/type-filter.component';

export const TypeFilterWrapper = () => {
    return (
        <Filter label={translate('filter_type')} data-testid="type-filter-wrapper">
            <TypeFilter />
        </Filter>
    );
};
